import React from "react";
import { Grid, useTheme, Container } from "@mui/material";
import ContactForm from "../../components/site/ContactForm";
import { GoogleReCaptchaProvider } from "gatsby-frontend";

export default function ContactPage() {
	const theme = useTheme();
	return (
		<GoogleReCaptchaProvider
			reCaptchaKey={process.env.GATSBY_RECAPTCHA_SITE_KEY}
		>
			<Container
				maxWidth={theme?.customOptions?.containerMaxWidth || "xl"}
				sx={{ padding: theme.spacing(3, 0) }}
			>
				<Grid container spacing={5} sx={{ justifyContent: "center" }}>
					<Grid item xs={6}>
						<ContactForm />
					</Grid>
				</Grid>
			</Container>
		</GoogleReCaptchaProvider>
	);
}
